import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigService } from '../core/config.service';
import { Stream } from '../dashboard/stream.service';
import { Settings } from './location.service';
import { AuthService } from '../core/auth.service';

export interface Autoset {
  automation_set_name: string;
  automation_set_id: string;
  template_autoset_id: string;
  settings?: Settings;
}

export interface AutosetSettings {
  automation_set_id: string;
  settings: Settings;
}

export interface AutosetStreams {
  streams: Stream[];
}

@Injectable()
export class AutosetService {
  constructor(private config: ConfigService, private httpClient: HttpClient, private auth: AuthService) {}

  getAllSubroomsP(roomId) {
    const url = `${this.config.getAutosetUrl()}/automation-sets/list/${roomId}`;
    return this.httpClient.get<Autoset[]>(url).toPromise();
  }

  getSubroomByIdP(locationId, roomId, autosetId) {
    const url = `${this.config.getBaseUrl()}/locations/${locationId}/rooms/${roomId}/subrooms/${autosetId}`;
    return this.httpClient.get<Autoset>(url).toPromise();
  }

  getSettingsForAutosetP(locationId, roomId, autosetId) {
    const url = `${this.config.getBaseUrl()}/locations/${locationId}/rooms/${roomId}/subrooms/${autosetId}/settings`;
    return this.httpClient.get<AutosetSettings>(url).toPromise();
  }

  putSettingsForAutosetP(room_id, automation_set_id, reqBody: Settings) {
    const settingsUrl = this.config.getSettingsUrl();

    const url = this.auth.isAdmin()
      ? `${settingsUrl}/rooms/${room_id}/automation-sets/${automation_set_id}/settings/admin`
      : `${settingsUrl}/rooms/${room_id}/automation-sets/${automation_set_id}/settings`;

    return this.httpClient.post<Settings>(url, reqBody).toPromise();
  }

  getStreamsForAutosetP(locationId, roomId, autosetId) {
    const url = `${this.config.getBaseUrl()}/locations/${locationId}/rooms/${roomId}/subrooms/${autosetId}/streams`;
    return this.httpClient.get<AutosetStreams>(url).toPromise();
  }

  clearOverrideSetting(room_id, automation_set_id) {
      const url = `${this.config.getSettingsV2Url()}/rooms/${room_id}/automation-sets/${automation_set_id}/settings/clear`;
      return this.httpClient.post<Autoset>(url, '').toPromise();
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/locations/autosets.service.ts